export function getAgencyReviewStats(agents = [], agencyReviews = []) {
  let totalCount = 0;
  let starSum = 0;

  const agentList = Array.isArray(agents) ? agents : [];
  for (const agent of agentList) {
    const reviews = Array.isArray(agent?.reviews) ? agent.reviews : [];
    for (const review of reviews) {
      totalCount += 1;
      const star = Number(review?.star ?? review?.rating);
      if (Number.isFinite(star)) starSum += star;
    }
  }

  if (totalCount === 0) {
    const agencyList = Array.isArray(agencyReviews) ? agencyReviews : [];
    for (const review of agencyList) {
      totalCount += 1;
      const star = Number(review?.star ?? review?.rating);
      if (Number.isFinite(star)) starSum += star;
    }
  }

  const average = totalCount > 0 ? starSum / totalCount : 0;

  return {
    average: Math.round(average * 100) / 100,
    totalCount,
  };
}

export function formatAgencyReviewAverage(average) {
  if (!Number.isFinite(average) || average <= 0) return "0";
  const rounded = Math.round(average * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
}
